export default {
  PENDING: 'PENDING',
  QUEUED: 'QUEUED',
  SENT: 'SENT',
  ERROR: 'ERROR',
  SENT_TEST: 'SENT_TEST',
};
